// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3706":"ec1178bc1cc76973","6045":"4081851b3ccdbae5"}[chunkId] + ".js";
};